import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

// import {TranslateYPipe} from "libComm/pipes/translate-y.pipe";
// import {LibCommModule} from '../../modules/libComm.module';
// import {TranslateLoader, TranslateModule} from "@ngx-translate/core";

@Component({
	selector: 'app-dialog',
	templateUrl: './dialog.component.html',
	styleUrls: ['./dialog.component.scss']
})
export class DialogComponent
{

	@Output()
	onConfirm: EventEmitter<any> = new EventEmitter<any>();

	constructor(
		public dialogRef: MatDialogRef<DialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	)
	{
		dialogRef.disableClose = true;
	}

	onNoClick()
	{
		this.onConfirm.emit(false);
		this.dialogRef.close();
	}

	onConfirmClick()
	{
		this.onConfirm.emit(true);
		this.dialogRef.close();
	}
}
